import React from 'react'

import EditPolicy from './EditPolicy'

export const EditPolicyTemplate = props => <EditPolicy {...props} type='template' />
export const EditPolicyDraft = props => <EditPolicy {...props} type='policy' draft />
export const EditPolicyTemplateDraft = props => <EditPolicy {...props} type='template' draft />
